import React from "react";
import { SwitchStatus, MobileContainerAnimation, MobileCardItem, LinkAnimation, Chip, CanSwitch } from "../../../../";
import { makeStyles, Typography } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    content: {
      padding: "72px 8px 12px 8px",
      width: "100%"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    my12: {
      margin: "12px 0"
    },
    my8: {
      margin: "8px 0"
    },
    containerAlert: {
      margin: "4px 0",
      padding: "4px 8px",
      borderRadius: "8px",
      background: theme.palette.secondary.main
    },
    containerFlexRowWrap: {
      display: "flex",
      width: "100%",
      flexFlow: "row wrap"
    },
    mt12b8: {
      margin: "12px 0 8px 0"
    },
    chipGroup: {
      border: "1px solid ".concat(theme.palette.text.primary),
      borderRadius: "8px",
      background: theme.palette.background.paper,
      margin: "4px"
    }
  };
});

var MobileCampusUser = function MobileCampusUser(props) {
  // console.log("MobileCampusUser props", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.textAnimation7s
  }, props.userName || ""))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, props.data ? props.data.allergies ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.mt12b8
      }, props.translation ? props.translation.titles ? props.translation.titles.allergies || "Allergies" : "Allergies" : "Allergies"), /*#__PURE__*/React.createElement("div", {
        className: classes.containerAlert
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, props.data ? props.data.allergies || "" : ""))) : null : null, /*#__PURE__*/React.createElement(CanSwitch, {
        role: props.role,
        coordinator: function coordinator() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: classes.mt12b8
          }, props.translation ? props.translation.titles ? props.translation.titles.parents || "Parents" : "Parents" : "Parents"), props.data ? props.data.parents ? props.data.parents.map(function (parent) {
            return /*#__PURE__*/React.createElement(MobileCardItem, {
              template: "userParentsListStaff",
              data: parent,
              classes: classes.my8
            });
          }) || null : null : null, props.data && props.data.extraResponsibles && props.data.extraResponsibles.length > 0 && /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: classes.mt12b8
          }, props.translation ? props.translation.titles ? props.translation.titles.extraResponsibles || "Extra responsibles" : "Extra responsibles" : "Extra responsibles"), props.data ? props.data.extraResponsibles ? props.data.extraResponsibles.map(function (responsible) {
            return /*#__PURE__*/React.createElement(MobileCardItem, {
              template: "userParentsListStaff",
              data: responsible,
              classes: classes.my8
            });
          }) || null : null : null);
        }
      }), props.data && props.data.comments && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.mt12b8
      }, props.translation ? props.translation.titles ? props.translation.titles.comments || "Comments" : "Comments" : "Comments"), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption"
      }, props.data ? props.data.comments || "" : "")), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.mt12b8
      }, props.translation ? props.translation.titles ? props.translation.titles.groups || "Groups" : "Groups" : "Groups"), /*#__PURE__*/React.createElement("div", {
        className: classes.containerFlexRowWrap
      }, props.data ? props.data.groups ? props.data.groups.map(function (group) {
        return /*#__PURE__*/React.createElement(Chip, {
          label: group.name,
          className: classes.chipGroup
        });
      }) || null : null : null));
    }
  })));
};

export { MobileCampusUser };